import React from "react";

export const about = {
  services: [
    {
      iconClass: "fa-solid fa-gem",
      title: "Creative Designer",
      description:
        "Crafting designs that anchor impactful online journeys and foster growth.",
      aboutMe: "Here are some things I enjoy designing:",
      aboutMeDescription: "UX/UI, Web, Apps, Logos",
      tools: "Design Tools:",
      toolsDescription: [
        "Adobe XD",
        "Webflow",
        "Figma",
        "Sketch",
        "Photoshop",
        "InVision",
        "Adobe Spark",
        "Canva",
        "Procreate",
      ],
    },
    {
      iconClass: "fa-solid fa-code",
      title: "Versatile Developer",
      description:
        "Offering a blend of frontend and backend expertise to bring your digital vision to life.",
      aboutMe: "Languages I speak:",
      aboutMeDescription: "English, Urdu, Hindi",
      tools: "Technologies I use:",
      // List out all the main technologies you use
      toolsDescription: [
        "React.js",
        "Next.js",
        "Gatsby.js",
        "React Native",
        "Node.js",
        "PHP",
        "MongoDB",
        "MySQL",
        "PostgreSQL",
        "AWS",
        "Firebase",
        "Azure",
        "GraphQL",
        "Shopify",
        "WordPress",
        "Webflow",
        "Strapi",
        "Sanity",
      ],
    },
  ],
  facts: [
    {
      iconClass: "fa-solid fa-users",
      value: "150+",
      name: "Happy Clients",
    },
    {
      iconClass: "fa-solid fa-project-diagram",
      value: "140+",
      name: "Project Delivered",
    },
    {
      iconClass: "fa-solid fa-medal",
      value: "5+",
      name: "Years of Experience",
    },
  ],
  values: [
    {
      iconClass: "fa-solid fa-asterisk fs-2 text-dark",
      title: "Innovation",
      description:
        "Think ahead and offer new ideas to help your business grow.",
    },
    {
      iconClass: "fa-solid fa-check fs-2 text-dark",
      title: "Action",
      description:
        "Objects, ideas, issues, action patterns or characteristics are based on values. We are not just a bunch of people who are doing something.",
    },
    {
      iconClass: "fa-solid fa-award fs-2 text-dark",
      title: "Quality",
      description:
        "Engage the right people with the right experience to help you grow. ",
    },
  ],
  whatIDo: [
    {
      tools: "Frontend:",
      toolsDescription: ["React.js", "Next.js", "Gatsby.js", "React Native"],
    },
    {
      tools: "Backend:",
      toolsDescription: ["Node.js", "PHP", "MySQL", "AWS", "Azure", "GraphQL"],
    },
    {
      tools: "Database:",
      toolsDescription: ["MongoDB", "MySQL", "PostgreSQL"],
    },
    {
      tools: "CMS:",
      toolsDescription: ["WordPress", "Webflow", "Strapi", "Sanity"],
    },
    {
      tools: "Design:",
      toolsDescription: ["Figma", "Adobe XD", "Sketch", "Photoshop"],
    },
    {
      tools: "cloud:",
      toolsDescription: ["AWS", "Firebase", "Azure"],
    },
  ],
};

export const projects = [
  {
    imagePath: "/images/projects/web/holland-america.webp",
    title: "Holland America",
    description:
      "Find Cruise Packages for Holland America's Award-Winning Cruises",
    url: "https://www.hollandamerica.com/en_US.html",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/adc.webp",
    title: "Debt Relief & Settlement in Texas - ADC",
    description:
      "ADC Texas-Based Debt Relief and Settlement Services Can Help You Regain Financial Stability. Call Now at 800-816-1003 for a Free Consultation.",
    url: "https://affordabledebtconsolidation.com",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/epleyer.webp",
    title: "Epleyer",
    description:
      "Create Your Free Esports Profile, Live Streaming, Game Stats, Videos, Photos, Social Media and so much more",
    url: "https://epleyer.gg",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/future-condos.webp",
    title: "Future Condos",
    description:
      "Future Condos is a platforms that curates the hottest pre-construction projects in North America",
    url: "https://www.futurecondos.io/",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/trustmeup.webp",
    title: "Trust Me Up",
    description:
      "Turn Every Purchase into a Donation and Reward Every Donation 100% in Discounts For Purchases",
    url: "https://www.trustmeup.com/",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/helios.webp",
    title: "Helios",
    description:
      "The new way to analyse meaning using the true metric of the human nature the voice",
    url: "https://helioslife.enterprises",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/nickelfox.webp",
    title: "Nickelfox",
    description:
      "Nickelfox is a indian based company for full stack software development, and web design and app development",
    url: "https://nickelfox.com",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/cpc.webp",
    title: "Command Performance Constructors",
    description:
      "Three generations of paving and heavy civil experience at your service",
    url: "https://www.cpconstructors.com/",
    category: "web",
  },
  // {
  //   imagePath: "/images/projects/web/cpc-admin.png",
  //   title: "Command Performance Constructors - Admin",
  //   description:
  //     "Three generations of paving and heavy civil experience at your service - Admin",
  //   url: "https://www.admin.cpconstructors.com/",
  //   category: "web",
  // },
  // {
  //   imagePath: "/images/projects/web/legal-pundits.png",
  //   title: "Legal Pundits",
  //   description:
  //     "We offer advices and representations to individuals and small to medium enterprises in legal issues such as tax disputes, contracts, family disputes and others",
  //   url: "https://legalpundits.net/",
  //   category: "web",
  // },
  // {
  //   imagePath: "/images/projects/web/resource-management.png",
  //   title: "Resource Management",
  //   description: "Track and Manage Resource Workload",
  //   url: "https://resourcing.foxlabs.in",
  //   category: "web",
  // },
];

export const homeprojects = [
  {
    imagePath: "/images/projects/web/trustmeup.webp",
    title: "Trust Me Up",
    description:
      "Turn Every Purchase into a Donation and Reward Every Donation 100% in Discounts For Purchases",
    url: "https://www.trustmeup.com/",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/helios.webp",
    title: "Helios",
    description:
      "The new way to analyse meaning using the true metric of the human nature the voice",
    url: "https://helioslife.enterprises",
    category: "web",
  },
  {
    imagePath: "/images/projects/web/epleyer.webp",
    title: "Epleyer",
    description:
      "Create Your Free Esports Profile, Live Streaming, Game Stats, Videos, Photos, Social Media and so much more",
    url: "https://epleyer.gg",
    category: "web",
  },
];

export const collaborationsLogo = [
  "/images/collaboration/zen3.webp",
  "/images/collaboration/kapwise.webp",
  "/images/collaboration/nimmio.webp",
  "/images/collaboration/unvired.webp",
  "/images/collaboration/premierlister.webp",
  "/images/collaboration/jindal-group.webp",
  "/images/collaboration/nickelfox.webp",
  "/images/collaboration/pitchworx.webp",
  "/images/collaboration/hello-fello.webp",
  "/images/collaboration/epleyer.webp",
  "/images/collaboration/affordabledebtconsolidation.webp",
  "/images/collaboration/debtredemption.webp",
  // "/images/collaboration/yalda-hakim-foundation.webp",
  // "/images/collaboration/kyocera-Intelligence.webp",
];

export const questions = [
  {
    question: "How can I contact you and quickly get a quote for my project?",
    answer:
      "The best way to reach me is through the contact form on my website or by messaging me on my social media accounts. Please provide as much detail as possible about your project to receive a fast and accurate quote.",
  },
  {
    question:
      "Do you create designs from scratch or do you use pre-made themes?",
    answer:
      "Yes, I specialize in creating custom designs tailored to your specific needs. While I can work with pre-made themes if requested, my focus is on crafting unique and personalized designs for each project.",
  },
  {
    question: "Do you provide maintenance and warranty after project delivery?",
    answer:
      "Absolutely! I offer free support and maintenance for a period after project delivery, depending on the scope and complexity of the project. This ensures that your website remains secure, up-to-date, and functioning smoothly.",
  },
  {
    question: "How much does a website cost?",
    answer:
      "The cost of a website can vary depending on several factors, including the complexity of the design, features required, and the size of the project. Generally, my website projects start in the $2,000 range for basic business sites and increase based on the specific needs of each client.",
  },
  {
    question: "Do you work alone or do you have a team?",
    answer:
      "While I am the primary point of contact and oversee all projects, I also collaborate with a team of skilled developers and designers. This allows me to leverage diverse expertise and deliver high-quality results for my clients.",
  },
  // Additional question example:
  {
    question: "What technologies do you specialize in?",
    answer:
      "I specialize in various of technologies. Whether you need a static website or a dynamic web application, I have the expertise to bring your vision to life.",
  },
];

export const socialMediaLinks = [
  {
    link: "https://www.linkedin.com/in/hanzala-/",
    iconClass: "fa-linkedin",
  },
  {
    link: "https://github.com/justhanzala",
    iconClass: "fa-github",
  },
  {
    link: "https://twitter.com/justhanzala",
    iconClass: "fa-twitter",
  },
  {
    link: "https://www.upwork.com/freelancers/hanzala",
    text: "up",
  },
  {
    link: "https://www.youtube.com/channel/UCuotTM8ASzIH8T06p9uZt8Q",
    iconClass: "fa-youtube",
  },
  {
    link: "https://www.facebook.com/justhanzala",
    iconClass: "fa-facebook-f",
  },
  {
    link: "https://www.instagram.com/me.hanzala/",
    iconClass: "fa-instagram",
  },
  {
    link: "https://join.skype.com/invite/xNOYFg7bGhdM",
    iconClass: "fa-skype",
  },
];

export const mentorship = {
  plans: [
    {
      iconClass: "fa-solid fa-gem",
      title: "Spot Mentoring",
      price: "$100",
      description:
        "1 hour of personalized conversation and advice, no long-term commitment needed.",
      benefit: (
        <>
          <p className="mb-2 text-blue fw-bold">Good For:</p>
          <p className="mb-0 fw-semibold">All Developers</p>
        </>
      ),
      btnText: "Book a session",
      btnLink: "/mentorship/inquiry/?type=spot-mentoring",
    },
    {
      iconClass: "fa-solid fa-code",
      title: "Production Support",
      price: "$300",
      description:
        "4 hours of focused feedback and development critique to enhance your performance.",
      benefit: (
        <>
          <p className="mb-2 text-blue fw-bold">Great For:</p>
          <p className="mb-0 fw-semibold">Experienced Developers</p>
        </>
      ),
      btnText: "Improve your chops",
      btnLink: "/mentorship/inquiry/?type=production-support",
    },
    {
      iconClass: "fa-solid fa-book",
      title: "Custom Mentorship",
      price: "$1,000+",
      description:
        "A personalized coaching plan for professional growth and long-term success.",
      benefit: (
        <>
          <p className="mb-1 text-blue fw-bold">Best For:</p>
          <p className="mb-0 fw-semibold">All Developers & agencies</p>
        </>
      ),
      btnText: "Start your journey",
      btnLink: "/mentorship/inquiry/?type=custom-mentorship",
    },
  ],
  benefits: [
    {
      iconClass: "fa-solid fa-bezier-curve",
      title: "Tools",
      description:
        "Gain confidence and enhance your development skills with my guidance and support.",
    },
    {
      iconClass: "fa-solid fa-book",
      title: "Resources",
      description:
        "I'll provide valuable resources to enhance your learning experience.",
    },
    {
      iconClass: "fa-solid fa-diagram-project",
      title: "Networking",
      description:
        "I'll facilitate networking opportunities with other professionals to broaden your connections.",
    },
    {
      iconClass: "fa-solid fa-door-open",
      title: "Opportunity",
      description:
        "I'll assist you in making valuable introductions and finding potential work opportunities.",
    },
    {
      iconClass: "fa-solid fa-rocket",
      title: "Growth",
      description:
        "I'll help you identify blind spots and expedite your personal and professional growth.",
    },
  ],
  services: [
    {
      iconClass: "fa-fingerprint",
      title: "Authenticity",
      description:
        "No sugar-coated critiques here. I'm invested in your growth and committed to keeping it real. Together, we'll deconstruct and rebuild, creating something even better.",
      borderClass: "border-end border-bottom",
    },
    {
      iconClass: "fa-dumpster-fire",
      title: "Humility",
      description:
        "I don't claim to be at the pinnacle of development expertise, as I recognize there's always more to learn. Each day, I chase the ever-moving target of development, constantly seeking mastery.",
      borderClass: "border-bottom",
    },
    {
      iconClass: "fa-scale-balanced",
      title: "Equality",
      description:
        "To me, you're not just a mentee, but an esteemed developer and a peer in the industry. It's not just me teaching and you learning; it's a mutual exchange of knowledge and growth.",
      borderClass: "border-end border-bottom",
    },
    {
      iconClass: "fa-box-open",
      title: "Transparency",
      description:
        "While I may not have all the answers, I'm here to guide you by sharing valuable resources and insights gained from my personal journey as a developer. Together, we can explore and learn from the vast realm of knowledge available.",
      borderClass: "border-end",
    },
  ],
};

export const collaborationLogos = [
  {
    image: "/images/collaboration/zen3.webp",
    title: "Zen3 Infosolutions",
    link: "https://zen3tech.com/",
  },
  {
    image: "/images/collaboration/kapwise.webp",
    title: "Kapwise",
    link: "https://www.kapwise.com/",
  },
  {
    image: "/images/collaboration/nimmio.webp",
    title: "Nimmio",
    link: "https://www.instagram.com/nimmioofficial/",
  },
  {
    image: "/images/collaboration/unvired.webp",
    title: "Unvired",
    link: "https://unvired.com/",
  },
  {
    image: "/images/collaboration/premierlister.webp",
    title: "Premier Lister",
    link: "https://premierlister.com/",
  },
  {
    image: "/images/collaboration/jindal-group.webp",
    title: "Jindal Group",
    link: "https://thejindalgroup.com/",
  },
  // {
  //   image: "/images/collaboration/nickelfox.webp",
  //   title: "Nickelfox",
  // },
  {
    image: "/images/collaboration/pitchworx.webp",
    title: "Pitchworx",
    link: "https://www.pitchworx.com/",
  },
  {
    image: "/images/collaboration/hello-fello.webp",
    title: "Hello Fello",
  },
  {
    image: "/images/collaboration/epleyer.webp",
    title: "Epleyer",
    link: "https://epleyer.gg/",
  },
  {
    image: "/images/collaboration/affordabledebtconsolidation.webp",
    title: "Affordable Debt Consolidation",
    link: "https://affordabledebtconsolidation.com/",
  },
  {
    image: "/images/collaboration/debtredemption.webp",
    title: "Debt Redemption",
    link: "https://debtredemption.com/",
  },
  // {
  //   image: "/images/collaboration/yalda-hakim-foundation.webp",
  // },
  // {
  //   image: "/images/collaboration/kyocera-Intelligence.webp",
  // },
];

export const processToHelp = [
  {
    iconClass: "fa-handshake",
    title: "Honesty",
    description:
      "I believe in being honest and transparent with my clients. I'll always give you my honest opinion and provide you with the information you need to make informed decisions.",
    borderClass: "border-end border-bottom",
  },
  {
    iconClass: "fa-comments",
    title: "communication",
    description:
      "I believe in open and honest communication. I'll keep you informed every step of the way and make sure you're always in the loop.",
    borderClass: "border-bottom",
  },
  {
    iconClass: "fa-clock",
    title: "Delivery on Time",
    description:
      "I believe in delivering high-quality work on time and on budget. I'll work with you to set realistic timelines and make sure we meet them.",
    borderClass: "border-end border-bottom",
  },
  {
    iconClass: "fa-rocket",
    title: "Post Launch Support",
    description:
      "I believe in providing ongoing support to my clients. I'll be here to help you with any questions or issues you may have after your website is live.",
    borderClass: "border-end",
  },
];

export const links = [
  {
    title: "About",
    to: "/about",
    dropdown: false,
  },
  {
    title: "Work",
    to: "/projects",
    dropdown: false,
  },
  {
    title: "Expertise",
    to: "#",
    dropdown: true,
  },
  {
    title: "Articles",
    to: "/blog/",
    dropdown: false,
  },
  {
    title: "Contact",
    to: "/contact",
    dropdown: false,
  },
];
